// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"Icon_titleIcon__3oL2k","iconL":"Icon_iconL__2p6XO"};